import { Action } from "@ngrx/store/src/models";
import { RoleModel } from "../../models/RoleModel";
import { SystemRoleType } from "../../models/SystemRoleType";

export const QUERY_AVAILABLE_ROLES_BY_TYPE_SUCCESS = "[SecurityModule] Query Available Roles by Type Success";

export class QueryAvailableRolesByTypeSuccessAction implements Action {
  readonly type: string;

  constructor(public roleType: SystemRoleType, public payload: { items: RoleModel[] }) {
    this.type = QUERY_AVAILABLE_ROLES_BY_TYPE_SUCCESS;
  }
}



// WEBPACK FOOTER //
// ./src/app/security/store/actions/QueryAvailableRolesByTypeSuccessAction.ts